module.exports = __webpack_public_path__ + "b905e702a2839d9c2d4b31e2a0a2bd6a.png";